<template>
  <div>
    <div class="mt-4 d-flex align-center justify-space-between">
      <v-btn
        text
        small
        height="32"
        class="action-btn elevation-0 rounded-lg"
        @click="$router.push('/spm/events/eventsPage')"
      >
        <v-icon class="uikit-icon chevron-left size-20"/>
        <span class="ml-1 btn-text">Вернуться</span>
      </v-btn>

      <h3
        v-if="!isXs"
        style="word-break: break-word"
        class="text-end"
      >
        {{ event.name }}
      </h3>
    </div>

    <DirectoryTable
      title="Локации"
      :table-headers="tableHeaders"
      :data-loaded="dataLoaded"
      :table-loading="tableLoading"
      :data="locationList.list"
      @edit="edit"
      @remove="remove"
      @addBtnClick="dialog = true"
    />

    <LocationDialog
      :dialog="dialog"
      :save-btn-loading="saveBtnLoading"
      :selected-item="selectedItem"
      :is-show-mode="isShowMode"
      @save="saveLocation"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeLocation"
      @closeConfirmModal="closeConfirmDialog"
    />
  </div>
</template>

<script>
import { eventApi, locationApi } from '@/api'
import { Event, LocationList } from '@/models'
import LocationDialog from '@/components/Spm/Directories/Location/dialogs/LocationDialog'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import DirectoryTable from '@/components/Spm/Directories/DirectoryTable'
import TabsUI from '@/featureSlicedDesign/shared/ui/TabsUI.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'LocationPage',

  metaInfo: { title: 'Локации' },

  components: {
    TabsUI,
    DirectoryTable,
    LocationDialog,
    ConfirmDialog,
  },

  async created() {
    await this.getLocationParent()
    await this.getEvent()
    this.dataLoaded = true
  },

  data: () => ({
    filter: '',
    tableHeaders: [
      { text: 'id', value: 'id', sortable: false, align: 'start' },
      { text: 'Название', value: 'name', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '130px' },
    ],
    locationList: new LocationList(),

    event: new Event(),

    selectedItem: null,

    confirmDialog: false,
    dialog: false,

    isShowMode: false,

    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,
  }),

  computed: {
    ...mapGetters('breakpoint', ['isXs'])
  },

  methods: {
    async getLocationParent() {
      try {
        const data = await locationApi.getLocationByEventId(this.$route.params.id)
        if (data.length) data.forEach((obj) => this.locationList.add(obj))
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения данных')
      }
    },

    async getEvent() {
      try {
        const data = await eventApi.get(this.$route.params.id)
        this.event = new Event(data.event)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения мероприятия')
      }
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },

    async saveLocation(body) {
      try {
        this.saveBtnLoading = true
        const data = body.id ? await locationApi.update({ event: this.event, ...body }) :
          await locationApi.create({ event: this.event, ...body })
        body.id ? this.locationList.update(data) : this.locationList.add(data)
        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeLocation() {
      try {
        this.removeLoading = true
        await locationApi.remove(this.selectedItem.id)
        this.locationList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },
  },
}
</script>
